import React, { ReactElement, useEffect } from 'react';
import { InjectedWizardStepProps } from '../../../components/Steps/WizardStep';
import { useDataCollection } from '../../../../hooks';
import { Form } from 'formik';
import FormRadio from '../../../components/Form/FormRadio';
import { roomDispositionsOptions } from '../../../../data/enumerations';
import StepHeader from '../../../components/Layout/StepHeader';

const StepRoomDispositions = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, handleBlur, values } = useDataCollection();

    useEffect(() => {
        if (values.roomDispositions) { completeStep && completeStep(true); }
    }, [values, completeStep]);

    return (
        <Form>
            <div className="otz-main otz-main--room-dispositions">
                <StepHeader title="Jaké jsou dispozice vašeho domu?"/>
                <div className={'otz-main__grid'}>
                    {roomDispositionsOptions.map((option) => {
                        return (
                            <div key={option.value}>
                                <FormRadio
                                    name="roomDispositions"
                                    value={option.value}
                                    id={option.value}
                                    label={option.title}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className={'wiz-form-radio--fullwidth m-b-0'}
                                    checked={option.value === values.roomDispositions}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </Form>
    );
};

export default StepRoomDispositions;
